import React from "react"
import { OverlayTrigger, Tooltip as ReactTooltip } from "react-bootstrap"
import { Placement } from "react-bootstrap/esm/Overlay"
import "./tooltip.css"


interface Props {
    placement?: Placement
    delayShow?: number
    delayHide?: number
    message: JSX.Element
    children: JSX.Element
    tooltipId: string
}

const Tooltip: React.FC<Props> = ({
    delayShow = 250,
    delayHide = 400,
    placement = "top",
    message,
    children,
    tooltipId = "tooltip",
}) => {
    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: delayShow, hide: delayHide }}
            overlay={
                <ReactTooltip id={tooltipId} className='qm-tooltip' >
                    {message}
                </ReactTooltip>
            }
        >
            {children}
        </OverlayTrigger>
    )
}

export default Tooltip


// WEBPACK FOOTER //
// ./src/common/tooltip/Tooltip.tsx